// NOTE: Do NOT import interactive component modules here. Interactive components
// import this registry and importing components back creates a circular
// dependency that breaks HMR. Instead the registry stores the component name
// as a string and consumers resolve the actual component at runtime.

import linhasRegistry from "./linhasRegistry";
import fibonacciRegistry from "./fibonacciRegistry";
import canaisRegistry from "./canaisRegistry";
import gannRegistry from "./gannRegistry";
import formasRegistry from "./formasRegistry";
import anotacoesRegistry from "./anotacoesRegistry";
import riscoRegistry from "./riscoRegistry";
import alertasRegistry from "./alertasRegistry";

// Main interactive registry combining all categories.
// Each category contains multiple interactive entries keyed by a unique id.
// This structure mirrors the indicator registry pattern for consistency.
// Categories are organized following ChartIQ's logical grouping system.
const interactiveRegistry = {
  linhas: linhasRegistry,
  fibonacci: fibonacciRegistry,
  canais: canaisRegistry,
  gann: gannRegistry,
  formas: formasRegistry,
  anotacoes: anotacoesRegistry,
  risco: riscoRegistry,
  alertas: alertasRegistry,
};

export default interactiveRegistry;
